module.exports = __webpack_public_path__ + "img/2-lg.ec6742e8.jpg";